var render = function render(){var _vm=this,_c=_vm._self._c;return _c('tr',[_c('div',{style:(_vm.style)},[_c('p',{staticStyle:{"color":"#aaa","font-size":"14px"}},[_vm._v("Banner")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }